module.exports = __webpack_public_path__ + "static/media/prestation-bg-mobile.59a62c9f.bin";